export const PurchaseIndex = () => import("./Purchase/Index.vue");
export const PurchaseCreate = () => import("./Purchase/Create.vue");
export const PurchaseEdit = () => import("./Purchase/Edit.vue");
export const PurchaseView = () => import("./Purchase/View.vue");
export const SalesReturn = () => import("./Purchase/SalesReturn.vue");

export const ReceivedIndex = () => import("./Received/List.vue");
export const ReceivedCreate = () => import("./Received/Create.vue");
export const ReceivedEdit = () => import("./Received/Edit.vue");
export const ReceivedView = () => import("./Received/View.vue");

export const NoteSheet = () => import("./Received/NoteSheet.vue");
export const JournalNoteSheet = () => import("./Received/JournalNoteSheet.vue");

export const DailyCash = () => import("./Received/DailyCash.vue");
export const DailyCashEntry = () => import("./Received/DailyCashCreate.vue");

export const PaymentIndex = () => import("./Payment/Index.vue");
export const PaymentCreate = () => import("./Payment/Create.vue");
export const PaymentEdit = () => import("./Payment/Edit.vue");
export const PaymentView = () => import("./Payment/View.vue");

export const RecipeIndex = () => import("./Recipe/Index.vue");
export const RecipeCreate = () => import("./Recipe/Create.vue");
export const RecipePurchase = () => import("./Recipe/Purchase.vue");
export const RecipeEdit = () => import("./Recipe/Edit.vue");
export const RecipeView = () => import("./Recipe/View.vue");

export const JournalCompanyBillCreate = () => import("./Journal/CompanyBillCreate.vue");
export const JournalCreate = () => import("./Journal/Create.vue");
export const JournalView = () => import("./Journal/View.vue");

export const AuditIndex = () => import("./Audit/Index.vue");

export const AuditAssets = () => import("./Audit/Assets.vue");
export const LedgerDetails = () => import("./Audit/LedgerDetails.vue");
